(function($) {

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header.site-header').outerHeight();
var stickOffset = 400;

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    //our scroll position
    var st = $(document).scrollTop();
    
     // Make sure they scroll more than delta
     if(Math.abs(lastScrollTop - st) <= delta){
         return;
     }

     //if scrolled down and scroll position is greater than 800
     if (st > lastScrollTop && st > stickOffset){
     //add class of sticky and remove nav-down
       $('header.site-header').addClass('site-header--sticky').removeClass('nav-down');
       }
     //scroll up and if less than 800
     if (st < lastScrollTop && st < stickOffset){
         //remove nav-down
         $('header.site-header').removeClass('nav-down');
         //then remove sticky
           setTimeout(function(){
               $('header.site-header').removeClass('site-header--sticky');
           },200);

       }
       //scroll up and if greater than 800
       if (st < lastScrollTop && st > stickOffset){
           //show our nav
           $('header.site-header').addClass('nav-down');
       }

       lastScrollTop = st;
}

})(jQuery);
